import { getTimeRange } from 'utils'
import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_PAGINATED_TRENDING_TAGS_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useTrendingTags/index.tsx',
  name: 'Get paginated trending tags',
  message: 'Obtain trending tags paginated.',
}

export const DEFAULT_LIMIT = 10
export const DEFAULT_PAGINATION_TAKE = 3
export const DEFAULT_TIME_RANGE = getTimeRange('hour', 24)
